import { FormControl, ValidationErrors, Validators } from '@angular/forms';

const validCharacters = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

export class PasswordValidator extends Validators {
  static validate(control: FormControl): ValidationErrors | null {
    let result = null;

    if (control.value?.match(validCharacters) === null) {
      result = { password: true };
    }

    return result;
  }
}
